'use client'

import { createPixKey, deletePixKey, PixKey } from '@/lib/api/financial/digital-account-api'
import { useState } from 'react'
import { MdAccountBalanceWallet, MdAdd, MdDelete } from 'react-icons/md'
import { toast } from 'react-toastify'
import PasswordField from './password-field'

export default function PixKeysModal({
    pixKeys,
    onClose,
    onChange,
}: {
    pixKeys: PixKey[]
    onClose: () => void
    onChange: () => void
}) {
    const [password, setPassword] = useState('')
    const [busy, setBusy] = useState(false)

    const handleCreate = async () => {
        if (!password) return toast.warning('Confirme sua senha')
        setBusy(true)
        try {
            const res = await createPixKey(password)
            if (res.success) {
                toast.success('Chave criada')
                setPassword('')
                onChange()
            } else {
                toast.error(res.error || 'Erro ao criar chave')
            }
        } finally {
            setBusy(false)
        }
    }

    const handleDelete = async (id: string) => {
        if (!password) return toast.warning('Confirme sua senha antes de remover')
        if (!confirm('Remover esta chave PIX?')) return
        setBusy(true)
        try {
            const res = await deletePixKey(id, password)
            if (res.success) {
                toast.success('Chave removida')
                onChange()
            } else {
                toast.error(res.error || 'Erro ao remover')
            }
        } finally {
            setBusy(false)
        }
    }

    return (
        <div className="modal modal-open">
            <div className="modal-box max-w-md">
                <h3 className="font-bold text-lg flex items-center gap-2 mb-4">
                    <MdAccountBalanceWallet className="text-purple-500" /> Chaves PIX
                </h3>

                <div className="space-y-3 mb-4">
                    {pixKeys.length === 0 ? (
                        <p className="text-sm text-base-content/60 text-center py-6">Nenhuma chave cadastrada</p>
                    ) : (
                        pixKeys.map(k => (
                            <div key={k.id} className="flex items-center justify-between p-3 rounded-lg bg-base-200/40">
                                <div className="min-w-0">
                                    <div className="flex items-center gap-2 mb-1">
                                        <span className="badge badge-sm">{k.type}</span>
                                        <span className="badge badge-xs">{k.status}</span>
                                    </div>
                                    <p className="text-xs font-mono truncate">{k.key}</p>
                                </div>
                                <button className="btn btn-ghost btn-xs btn-circle text-error" onClick={() => handleDelete(k.id)} disabled={busy}>
                                    <MdDelete />
                                </button>
                            </div>
                        ))
                    )}
                </div>

                <div className="border-t border-base-300 pt-4">
                    <p className="text-sm font-medium mb-1">Criar chave aleatória</p>
                    <p className="text-xs text-base-content/60 mb-3">
                        Chaves de CPF, CNPJ, e-mail e telefone exigem confirmação de posse
                        junto ao Banco Central e precisam ser cadastradas no aplicativo da
                        conta digital. Depois de cadastradas lá, elas aparecem nesta lista.
                    </p>

                    <PasswordField value={password} onChange={setPassword} disabled={busy} />

                    <button
                        className="btn btn-secondary btn-sm w-full mt-3"
                        onClick={handleCreate}
                        disabled={busy}
                    >
                        <MdAdd /> Criar chave aleatória
                    </button>
                </div>

                <div className="modal-action">
                    <button className="btn btn-ghost btn-sm" onClick={onClose}>Fechar</button>
                </div>
            </div>
            <div className="modal-backdrop" onClick={onClose} />
        </div>
    )
}
